module.exports = __webpack_public_path__ + "static/img/diyiimg4.bbed23f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cardiobrain/diyiimg4.png
// module id = priY
// module chunks = 5